import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FiskalniRacuniClient } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-buyer-optional-field-dropdown',
  templateUrl: './buyer-optional-field-dropdown.component.html',
  styleUrls: ['./buyer-optional-field-dropdown.component.scss']
})
export class BuyerOptionalFieldDropdownComponent implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();

  /** Props */
  items: SelectItem[] = [];

  /** I/O */
  @Input() formCtrl!: AbstractControl;
  @Input() formCtrlId!: string;
  @Input() parentCtrl: any = 'body';

  constructor(
    private _fiskalniClient : FiskalniRacuniClient,
    private _cdr : ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._load().then();
  }

  private async _load() {
    this._subs.add(
      this._fiskalniClient.getBuyerOptionalField().subscribe((res) => {
        this.items = res.data!.buyerOptionalFieldDtoList!.map((x) => ({
          value: x.buyerOptionalField,
          label: x.buyerOptionalFieldStr,
          title: x.opis,
        }));
        this._cdr.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
